import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';

/**
 * 一括チェック制御
 * @example
 * <input type="checkbox" data-multicheck="agreement">
 *
 * <input type="checkbox" name="agreement" value="1">
 * <input type="checkbox" name="agreement" value="2">
 * <input type="checkbox" name="agreement" value="3">
 */
export default class MultiCheckBaseClass extends BaseClass {
  constructor(_id) {
    super();
    this.name = 'MultiCheckBaseClass';

    this.onChangeListener = this.onChange.bind(this);
    this.onTargetChangeListener = this.onTargetChange.bind(this);

    this.id = _id;
  }

  onCreate() {
    this.changeTarget = $('[data-multicheck=' + this.id + ']');
    this.target = $('input[name=' + this.id + ']');

    this.changeTarget.on('change', this.onChangeListener);
    this.target.on('change', this.onTargetChangeListener);
  }

  onChange(e) {
    this.target.prop('checked', $(e.currentTarget).prop('checked'));
  }

  onTargetChange(e) {
    let flag = true;
    this.target.each((index, element) => {
      if (flag && !$(element).prop('checked')) { flag = false; }
    });
    this.changeTarget.prop('checked', flag);
  }
}
